export interface IUserProfileModal {
  isOpen: boolean;
  onClose: () => void;
}

export enum ProfileScreensEnum {
  DEFAULT = 'DEFAULT',
  SETTINGS = 'SETTINGS',
}
